module.exports = __webpack_public_path__ + "img/mobile-film.af291df4.webp";